import { SVGProps } from 'react'

export const AlertCircle = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="38"
      height="37"
      viewBox="0 0 38 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.7689 31.8379C26.5432 31.8379 32.8455 25.7937 32.8455 18.3379C32.8455 10.882 26.5432 4.83789 18.7689 4.83789C10.9947 4.83789 4.69238 10.882 4.69238 18.3379C4.69238 25.7937 10.9947 31.8379 18.7689 31.8379Z"
        stroke="#FF3932"
        strokeWidth="2.34609"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7686 12.3379V18.3379"
        stroke="#FF3932"
        strokeWidth="2.34609"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7686 24.3379H18.7842"
        stroke="#FF3932"
        strokeWidth="2.34609"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
